import { createApp } from "vue";
import { createPinia } from "pinia";
import "./style.css";
import App from "./App.vue";
import router from "./routers/index.js";
import { useAuthStore } from "./stores/authStore";
import { i18n } from "./i18n/index.js";

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(i18n);
app.mount("#app");

const auth = useAuthStore();
if (auth.token && !auth.user) {
  auth.fetchUser();
}
